
























import { Component, Watch, Mixins } from 'vue-property-decorator';
import FaqMixin from '@/mixins/faq';

@Component
export default class FaqSearch extends Mixins(FaqMixin) {
  searchInput = '';

  mounted() {
    this.searchInput = this.search;
  }

  @Watch('searchInput')
  checkSearchEmpty(val: string) {
    if (val === '') {
      this.resetSearch();
    }
  }

  onEnter(e: InputEvent) {
    if (!e.isComposing && this.searchInput) {
      this.resetSearch();
      this.setSearch(this.searchInput);
      const queryObj = {
        query: this.searchInput,
        section: this.$route?.params.id
      };
      this.fetchQueriedArticles(queryObj);
    }
  }
}
